<form [formGroup]="form">
  <cdk-virtual-scroll-viewport
    itemSize="40"
    class="viewport"
    [style.height.px]="options.length > 4 ? 200 : options.length * 48"
  >
    <div *cdkVirtualFor="let item of options; let i = index; trackBy: trackByFn" class="option-row">
      <mat-checkbox [formControl]="form.controls.options!.at(i)" (change)="onSubmit()">
        <span class="checkbox-label-wrapper">
          {{ options[i].title }}
        </span>
      </mat-checkbox>
    </div>
  </cdk-virtual-scroll-viewport>
</form>
